import DialogLoaderButton from "@/components/loader-button/DialogLoaderButton";
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import { closeDialog } from "@/store/reducers/dialogReducer";
import React, { useState } from "react";
import { useDispatch } from "react-redux";

interface DialogFooterProps {
  disabled: boolean;
  loading: boolean;
  confirmationMode?: boolean;
  handleSubmit: () => void;
}

export const DialogFooter_: React.FC<DialogFooterProps> = ({
  loading,
  disabled,
  confirmationMode,
  handleSubmit,
}) => {
  const dispatch = useDispatch();
  const [isConfirmed, setIsConfirmed] = useState(false);

  const handleCancel = () => {
    if (isConfirmed) {
      setIsConfirmed(false);
    } else {
      dispatch(closeDialog());
    }
  };

  const displayLabel = () => {
    if (confirmationMode) {
      if (isConfirmed) {
        return "Confirmer";
      } else {
        return "Créer";
      }
    } else {
      return "Suivant";
    }
  };

  const handleConfirm = () => {
    if (confirmationMode) {
      if (isConfirmed) {
        handleSubmit();
      } else {
        setIsConfirmed(true);
      }
    } else {
      handleSubmit();
    }
  };

  return (
    <DialogFooter className="flex flex-col sm:flex-row gap-2 mt-4 items-center justify-between sm:justify-between">
      <div className="flex items-center gap-2">
        {isConfirmed && (
          <p className="text-sm text-gray-500">
            Voulez-vous vraiment créer une tournée avec ces demandes?
          </p>
        )}
      </div>
      <div className="flex gap-2">
        <Button variant="outline" onClick={handleCancel}>
          Annuler
        </Button>
        <DialogLoaderButton
          isLoading={loading}
          disabled={disabled}
          handleSubmit={handleConfirm}
          name={displayLabel()}
        />
      </div>
    </DialogFooter>
  );
};
